export default __webpack_public_path__ + "static/media/puppr-content-background-mobile.da393724.png";